import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ActorCardCmp_OrganizationMembership_Fragment = graphql(`
  fragment ActorCardCmp_OrganizationMembership_Fragment on OrganizationMembership {
    _id
    contextualRoleIds
    functions
    personId
    representativeTypeIds
    statusId
  }
`);

export type ActorCardCmp_OrganizationMembership = ResultOf<
  typeof ActorCardCmp_OrganizationMembership_Fragment
>;
